import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { RentalPricerDetailsStore } from '../stores/rentalPricerDetailsStore';

export const useRentalPricerDetailsStore = () => useContext<{
  rentalPricerDetailsStore: RentalPricerDetailsStore
}>(StoreContext);
